import {
  Box,
  Button,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import {
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import { getFieldByTitle } from "../../helpers/sortByTitle";
import { ReferralEntity } from "../../types/referrals";
import SettingsListTittle from "../common/listTitles/WinnersListTitle";
import HeadTable from "../common/sortTable/sortTable";
import TablesSearch from "../common/tablesSearch/tablesSearch";
import PaginationTable from "../common/paginationTable";
import "./style.css";
enum ReferralStatus {
  Active = "active",
  InActive = "inActive",
  IsPurchase = "isPurchase"
}

const RefferalsList = (props) => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const refresh = useRefresh();

  const notify = useNotify();
  const [state, setState] = useState({
    referrals: Array<ReferralEntity>(),
    total: 0,
    page: 1,
    perPage: 10,
    field: "_id",
    order: "asc",
  });

  const [dropdown, setDropdown] = useState({
    first: false,
    last: false,
    email: false,
    phone: false,
    user: false,
  });

  const [searchState, setSearchState] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    referrer: "",
  });

  const [filter, setFilter] = useState({
    // isActive: true,
    referralStatus: ReferralStatus.Active,
    searchField: "",
  });

  const [modal, setModal] = useState({
    showModal: false,
    id: "",
  });
  const [blockedFilter, setBlockedFilter] = useState({
    with: false,
    without: false,
  });

  const [checkedReferrals, setCheckedReferrals] = useState<Array<string>>([]);
  const [checkedByOne, setCheckedByOne] = useState<boolean>(false);
  const [checkAll, setCheckAll] = useState<boolean>(false);
  const [defaultNeededToSpentAmount, setNeededToSpentAmount] = useState<number>(100);
  const [defaultCreditsAmount, setDefaultCreditsAmount] = useState<number>(100);
  const defaultAmountInput = useRef<any>(null);
  useEffect(() => {
    getRefferals(ReferralStatus.Active, 1, 10, "_id", "asc", "", "", "", "", "");
  }, []);

  const getRefferals = async (
    referralStatus: string,
    page: number,
    perPage: number,
    field: string,
    order: string,
    searchEmail: string,
    searchName: string,
    searchSurname: string,
    searchPhone: string,
    searchUserReferrer: string
  ) => {
    const referrals = (await dataProvider.getList("users/referrals", {
      filter: {
        referralStatus,
        searchName,
        searchEmail,
        searchSurname,
        searchPhone,
        searchFromUserName: searchUserReferrer,
      },
      pagination: { page: page, perPage: perPage },
      sort: { field: field, order: order },
    })) as any;
    setState({
      ...state,
      referrals: referrals.data,
      total: referrals.total,
      page: page,
      perPage: perPage,
      field: field,
      order: order,
    });
    setNeededToSpentAmount(referrals.generalSettings.referralDefaultValue / 100)
    setDefaultCreditsAmount(referrals.generalSettings.referralCreditDefault / 100)
  };

  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(" ");
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };

  const handleSort = (direction: string, title: string) => {
    const field = getFieldByTitle(title);
    getRefferals(
      filter.referralStatus,
      state.page,
      state.perPage,
      field,
      direction,
      searchState.email,
      searchState.name,
      searchState.surname,
      searchState.phone,
      searchState.referrer
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const perPage = parseInt(event.target.value, 10);
    getRefferals(
      filter.referralStatus,
      1,
      perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      searchState.phone,
      searchState.referrer
    );
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ): void => {
    getRefferals(
      filter.referralStatus,
      newPage + 1,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      searchState.phone,
      searchState.referrer
    );
  };

  const handleLastPage = () => {
    const page = Math.ceil(state.total / state.perPage);
    getRefferals(
      filter.referralStatus,
      page,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      searchState.phone,
      searchState.referrer
    );
  };

  const handleFirstPage = () => {
    getRefferals(
      filter.referralStatus,
      1,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      searchState.phone,
      searchState.referrer
    );
  };
  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };

  const applySearch = (field: string) => {
    setFilter({ ...filter, searchField: field });
    getRefferals(
      filter.referralStatus,
      1,
      10,
      "_id",
      "asc",
      searchState.email,
      searchState.name,
      searchState.surname,
      searchState.phone,
      searchState.referrer
    );
  };
  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: "" });
  };
  const toUser = (id: string) => {
    redirect(`/users/${id}`);
    refresh();
  };

  const getRefferalsIds = async () => {
    const ids = await dataProvider.getUsersRefferalsIds();
    return {
      ids: ids.data,
    };
  };

  const setDefaultAmountNeededToSpend = async () => {
    try {
      let result;
      if (checkedReferrals.length > 1000) {
        while (checkedReferrals.length > 0) {
          const chunk = checkedReferrals.splice(0, 1000)
          result = await dataProvider.setReferralsDefaultAmountNeededToSpend({
            ids: chunk,
            amount: defaultNeededToSpentAmount,
          });
        }
      } else {
        result = await dataProvider.setReferralsDefaultAmountNeededToSpend({
          ids: checkedReferrals,
          amount: defaultNeededToSpentAmount,
        });
      }
      if (result.data) {
        notify(result.data.message, "info");
        getRefferals(
          filter.referralStatus,
          state.page,
          state.perPage,
          "_id",
          "asc",
          searchState.email,
          searchState.name,
          searchState.surname,
          searchState.phone,
          searchState.referrer
        );
      }
    } catch (error) {
      notify("Something wrong", "error");
    }
  };

  const sendDefaultCreditsAmount = async () => {
    try {
      let result
      if (checkedReferrals.length > 1000) {
        while (checkedReferrals.length > 0) {
          const chunk = checkedReferrals.splice(0, 1000)
          result = await dataProvider.setReferralsDefaultAmountCredits({
            ids: chunk,
            amount: defaultNeededToSpentAmount,
          });
        }
      } else {
        result = await dataProvider.setReferralsDefaultAmountCredits({
          ids: checkedReferrals,
          amount: defaultCreditsAmount,
        });
      }
      if (result.data) {
        notify(result.data.message, "info");
        getRefferals(
          filter.referralStatus,
          state.page,
          state.perPage,
          "_id",
          "asc",
          searchState.email,
          searchState.name,
          searchState.surname,
          searchState.phone,
          searchState.referrer
        )
      }
    } catch (error) {
      notify("Something wrong", "error");
    }
  }

  const setAllReferralsChecked = async () => {
    const refferalsIds = await getRefferalsIds();
    setCheckedReferrals([...refferalsIds.ids]);
  };
  useEffect(() => {
    if (checkAll) {
      setCheckedByOne(false);
      setAllReferralsChecked();
      return;
    }
    if (!checkAll && !checkedByOne) {
      setCheckedReferrals([]);
      return;
    }
  }, [checkAll]);

  const onToggleItem = (id: string) => (e: any) => {
    setCheckedByOne(true);
    setCheckAll(false);
    const containeIdIndex = checkedReferrals
      ? checkedReferrals.findIndex((i) => i === id)
      : null;
    if (containeIdIndex !== null) {
      if (containeIdIndex === -1) {
        setCheckedReferrals([...checkedReferrals, id]);
        return;
      }
      setCheckedReferrals([
        ...checkedReferrals.slice(0, containeIdIndex),
        ...checkedReferrals.slice(containeIdIndex + 1, checkedReferrals.length),
      ]);
    }
  };
  const onToggleAll = (e: any) => {
    setCheckAll(!checkAll);
  };

  const handleSetDefaultAmountNeededToSpend = () => {
    if (defaultNeededToSpentAmount !== 0) {
      setDefaultAmountNeededToSpend();
    } else {
      notify("Please enter valid value ", "error")
    }
  };

  const handleSetDefaultCreditsAmount = () => {
    if (defaultCreditsAmount !== 0) {
      sendDefaultCreditsAmount()
    } else {
      notify("Please enter valid value ", "error")
    }
  }

  const handleChangeDefaultAmountValue = (e: any) => {
    if (e.target.name === "defaultNeededToSpentAmount") {
      if(e.target.value >=0){
        setNeededToSpentAmount(+e.target.value);
      }
    }
    if (e.target.name === "defaultCreditsAmount") {
      if(e.target.value >=0){
        setDefaultCreditsAmount(+e.target.value);
      }
    }
  };

  const handleSwitchReferralsStatus = (e: any) => {
    setFilter({
      ...filter,
      referralStatus: e.currentTarget.name
    })
    getRefferals(
      e.currentTarget.name,
      state.page,
      state.perPage,
      "_id",
      "asc",
      searchState.email,
      searchState.name,
      searchState.surname,
      searchState.phone,
      searchState.referrer
    );
  }
  return (
    <>
      <SettingsListTittle title="Refferals" hideAddButton={false} isShow={false}/>
      <Box className="referralListCardWrapper">
        <Box
          display="flex"
          justifyContent="flex-end"
          marginBottom='1rem'>
          <div className='referralsStatusButtonsGroup'>
            <Button name={`${ReferralStatus.Active}`} className={filter.referralStatus === ReferralStatus.Active ? "switchStatusBtn switchStatusBtn-active" : "switchStatusBtn"} onClick={handleSwitchReferralsStatus}>New</Button>
            <Button name={`${ReferralStatus.IsPurchase}`} className={filter.referralStatus === ReferralStatus.IsPurchase ? "switchStatusBtn switchStatusBtn-active" : "switchStatusBtn"} onClick={handleSwitchReferralsStatus}>Active </Button>
            <Button name={`${ReferralStatus.InActive}`} className={filter.referralStatus === ReferralStatus.InActive ? "switchStatusBtn switchStatusBtn-active" : "switchStatusBtn"} onClick={handleSwitchReferralsStatus}>Archive</Button>
          </div>
        </Box>
        {filter.referralStatus === ReferralStatus.Active &&
          <Box
            display="flex"
            alignItems="center"
            paddingBottom={2}
            paddingTop={2}
          >
            <Box display="flex" width={'50%'} alignItems="center">
              <Typography className="base-color">Default amount of £</Typography>
              <TextField
                size="small"
                type="number"
                InputProps={{
                  inputProps: {
                    min: 1,
                  },
                }}
                className="defaultAmountInput"
                name="defaultNeededToSpentAmount"
                error={!defaultNeededToSpentAmount}
                value={defaultNeededToSpentAmount}
                onChange={handleChangeDefaultAmountValue}
                variant="outlined"
              />
              <Box marginLeft={2.5}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSetDefaultAmountNeededToSpend}
                >
                  Save default value for users
                </Button>
              </Box>
            </Box>
            <Box display="flex" width={'50%'} alignItems="center">
              <Box marginRight=".8rem">
                <Typography className="base-color">Default amount of credits  </Typography>
              </Box>
              <TextField
                size="small"
                type="number"
                InputProps={{
                  inputProps: {
                    min: 1,
                  },
                }}
                error={!defaultCreditsAmount}
                className="defaultAmountInput"
                name="defaultCreditsAmount"
                value={defaultCreditsAmount}
                onChange={handleChangeDefaultAmountValue}
                variant="outlined"
              />
              <Box marginLeft={2.5}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSetDefaultCreditsAmount}
                >
                  Save default value for users
                </Button>
              </Box>
            </Box>
          </Box>
        }
        <Box marginTop="0.5em">
          <Card>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {filter.referralStatus === ReferralStatus.Active &&
                      <TableCell padding="checkbox">
                        <Checkbox checked={checkAll} onClick={onToggleAll} />
                      </TableCell>
                    }
                    <TableCell id="active-table-head">
                      <HeadTable
                        title="First Name"
                        sort={handleSort}
                        filterHandle={filterDropdown}
                      />
                      {dropdown.first && (
                        <TablesSearch
                          search={(event) =>
                            search(event.currentTarget.value, "name")
                          }
                          applySearch={() => applySearch("name")}
                          searchString={searchState.name}
                          clearSearch={() => clearSearch("name")}
                        />
                      )}
                    </TableCell>
                    <TableCell id="active-table-head">
                      <HeadTable
                        title="Last Name"
                        sort={handleSort}
                        filterHandle={filterDropdown}
                      />
                      {dropdown.last && (
                        <TablesSearch
                          search={(event) =>
                            search(event.currentTarget.value, "surname")
                          }
                          applySearch={() => applySearch("surname")}
                          searchString={searchState.surname}
                          clearSearch={() => clearSearch("surname")}
                        />
                      )}
                    </TableCell>
                    <TableCell id="active-table-head">
                      <HeadTable
                        title="Email address"
                        sort={handleSort}
                        filterHandle={filterDropdown}
                      />
                      {dropdown.email && (
                        <TablesSearch
                          search={(event) =>
                            search(event.currentTarget.value, "email")
                          }
                          applySearch={() => applySearch("email")}
                          searchString={searchState.email}
                          clearSearch={() => clearSearch("email")}
                        />
                      )}
                    </TableCell>
                    <TableCell id="active-table-head">
                      <HeadTable
                        title="Phone"
                        sort={handleSort}
                        filterHandle={filterDropdown}
                      />
                      {dropdown.phone && (
                        <TablesSearch
                          search={(event) =>
                            search(event.currentTarget.value, "phone")
                          }
                          applySearch={() => applySearch("phone")}
                          searchString={searchState.phone}
                          clearSearch={() => clearSearch("phone")}
                        />
                      )}
                    </TableCell>
                    <TableCell id="active-table-head">
                      <HeadTable
                        title="Spent/Needed to spend"
                        sort={handleSort}
                      />
                    </TableCell>
                    <TableCell id="active-table-head">
                      <HeadTable
                        title="User"
                        sort={handleSort}
                        filterHandle={filterDropdown}
                      />
                      {dropdown.user && (
                        <TablesSearch
                          search={(event) =>
                            search(event.currentTarget.value, "referrer")
                          }
                          applySearch={() => applySearch("referrer")}
                          searchString={searchState.referrer}
                          clearSearch={() => clearSearch("referrer")}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                </TableHead>
                {state.referrals.map((item) => {
                  return (
                    <TableBody
                      key={item.email}
                      className={item._id === modal.id ? "mark-user-row" : ""}
                    >
                      <TableRow>
                        {filter.referralStatus === ReferralStatus.Active &&
                          <TableCell>
                            <Checkbox
                              checked={
                                !!checkedReferrals.find((i) => i === item._id)
                              }
                              onClick={onToggleItem(item._id)}
                            />
                          </TableCell>}
                        <TableCell>
                          <div
                            className="move-search-user"
                            onClick={() => toUser(item._id)}
                          >
                            {item.name}{" "}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div
                            className="move-search-user"
                            onClick={() => toUser(item._id)}
                          >
                            {item.surname}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div
                            className="move-search-user"
                            onClick={() => toUser(item._id)}
                          >
                            {item.email}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div
                            className="move-search-user"
                            onClick={() => toUser(item._id)}
                          >
                            {item.phone}
                          </div>
                        </TableCell>
                        <TableCell>{`${item.spentMoney/100}/${item.neededSpend/100}`}</TableCell>
                        <TableCell>{item.fromUserName?<div
                          className="move-search-user"
                          onClick={() => toUser(item.fromUserId)}
                        >{`${item.fromUserName}`}</div>: <div className="base-color">User deleted</div>}</TableCell>
                      </TableRow>
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
            <PaginationTable
              page={state.page}
              perPage={state.perPage}
              collectionLength={state.referrals.length}
              total={state.total}
              handleChangePage={handleChangePage}
              handleLastPage={handleLastPage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleFirstPage={handleFirstPage}
              title="Refferals"
            />
          </Card>
        </Box>
      </Box>
    </>
  );
};

export default RefferalsList;
